import { CRITERIA_GROUP, INDICATOR_TYPE } from '../../common/constant'
import { isNumeric } from '../../common/helper'
import { ERROR_TYPE } from './../../common/constant'

export const handleValidateCriteria = (criteria) => {
  let isValid = true

  ;[CRITERIA_GROUP.BASIC_INFORMATION, CRITERIA_GROUP.FINANCIALS].forEach(
    (group) => {
      const groupData = criteria[group]
      Object.keys(groupData).forEach((key) => {
        const indicator = groupData[key]
        if (indicator) {
          switch (indicator.indicatorType) {
            case INDICATOR_TYPE.TextBox:
              Object.keys(indicator.data).forEach((key) => {
                if (indicator.data[key] && !indicator.data[key]?.value) {
                  indicator.data[key].error = ERROR_TYPE.REQUIRED
                  isValid = false
                }
              })
              break
            case INDICATOR_TYPE.NumberRange:
            case INDICATOR_TYPE.FloatRange:
            case INDICATOR_TYPE.FinancialRange:
            case INDICATOR_TYPE.RatioRange:
              Object.keys(indicator.data).forEach((key) => {
                if (
                  !isNumeric(indicator.data[key]?.from) &&
                  !isNumeric(indicator.data[key]?.to)
                ) {
                  indicator.data[key].error = ERROR_TYPE.REQUIRED
                  isValid = false
                }
              })
              break
            case INDICATOR_TYPE.DateTimeRange:
              Object.keys(indicator.data).forEach((key) => {
                if (!indicator.data[key]?.from && !indicator.data[key]?.to) {
                  indicator.data[key].error = ERROR_TYPE.REQUIRED
                  isValid = false
                }
              })
              break
            case INDICATOR_TYPE.DropdownList:
              if (
                !indicator.data ||
                !Object.values(indicator.data).filter(Boolean).length
              ) {
                indicator.error = ERROR_TYPE.REQUIRED
                isValid = false
              }
              break
            case INDICATOR_TYPE.MultipleDropdownList:
              if (!indicator.data || !indicator.data.length) {
                indicator.error = ERROR_TYPE.REQUIRED
                isValid = false
              }
              break
            default:
              break
          }
        }
      })
    },
  )

  return isValid
}
